// Map label and work-order id for a target sampling point. File-owned layers
// show and order the uploaded id. Every other layer keeps the ordinal label.

export const TARGET_POINT_TEXT_FIELD = [
  "case",
  ["==", ["get", "id_source"], "file"],
  ["to-string", ["coalesce", ["get", "point_id"], ""]],
  ["to-string", ["coalesce", ["get", "code"], ["get", "num"], ""]],
];

export function orderPointId(
  properties:
    | {
        point_id?: unknown;
        num?: unknown;
        id_source?: unknown;
      }
    | null
    | undefined,
  index: number,
): string {
  const source = properties?.id_source;
  if (source === "file" || source === "ordinal") {
    const raw = properties?.point_id;
    if (raw != null && String(raw).trim() !== "") return String(raw);
  }
  const num = properties?.num;
  const n = typeof num === "number" && Number.isFinite(num) ? num : index + 1;
  return `P-${n}`;
}

export function targetSavedLine(
  fieldName: string,
  points: number,
  idSource: "file" | "ordinal",
  detail?: {
    alreadyExisted?: boolean;
    inserted?: number;
    layerTitle?: string | null;
  },
): string {
  const ids = idSource === "file" ? "IDs from file" : "numbered in file order";
  // An identical upload returns the existing set. already_existed is that signal.
  if (detail?.alreadyExisted) {
    const n =
      typeof detail.inserted === "number" && Number.isFinite(detail.inserted)
        ? detail.inserted
        : points;
    const title = detail.layerTitle?.trim();
    const named = title ? `${fieldName} — ${title}` : fieldName;
    return `Already saved: ${named} — ${n} points (${ids}). No new layer was created.`;
  }
  return `Target layer saved: ${fieldName} — ${points} points (${ids})`;
}

export function targetLayerTitle(
  layers: readonly { id: string; title?: string | null }[] | null | undefined,
  layerId: string | null | undefined,
): string | undefined {
  if (!layerId || !layers) return undefined;
  const title = layers.find((layer) => layer.id === layerId)?.title?.trim();
  return title || undefined;
}

export function targetAttachLine(
  row: {
    fieldName: string;
    points: number;
    idSource: "file" | "ordinal";
    alreadyExisted?: boolean;
    inserted?: number;
    layerId?: string;
  },
  layers?: readonly { id: string; title?: string | null }[] | null,
): string {
  return targetSavedLine(row.fieldName, row.points, row.idSource, {
    alreadyExisted: row.alreadyExisted,
    inserted: row.inserted,
    layerTitle: row.alreadyExisted
      ? targetLayerTitle(layers, row.layerId)
      : undefined,
  });
}
